// 泸州区域配置信息
const LzSet = {
// 工种
    cultureleveltype:[
        { id: '1', name: '小学'},
        { id: '2', name: '初中'},
        { id: '3', name: '高中'},
        { id: '4', name: '中专'},
        { id: '5', name: '大专'},
        { id: '6', name: '本科'},
        { id: '7', name: '硕士'},
        { id: '8', name: '博士'},
        { id: '99', name: '其他'}
    ],
    // 工资卡银行代码
    payrolltopbankcode:[
        { id: '103', name: '中国农业银行' },
        { id: '201', name: '国家开发银行' },
        { id: '104', name: '中国银行' },
        { id: '100', name: '中国邮政储蓄银行（收单）' },
        { id: '301', name: '交通银行' },
        { id: '203', name: '中国农业发展银行' },
        { id: '001', name: '银联商务（收单）' },
        { id: '501', name: '汇丰银行' },
        { id: '503', name: '南洋商业银行' },
        { id: '318', name: '渤海银行股份有限公司' },
        { id: '401', name: '城市信用社' },
        { id: '533', name: '摩根大通银行(中国)有限公司' },
        { id: '564', name: '瑞穗实业银行（中国）有限公司' },
        { id: '506', name: '集友银行有限公司' },
        { id: '510', name: '永亨银行（中国）有限公司' },
        { id: '202', name: '中国进出口银行' },
        { id: '302', name: '中信银行' },
        { id: '102', name: '中国工商银行' },
        { id: '105', name: '中国建设银行' },
        { id: '311', name: '上海银联商务/东莞商业银行' },
        { id: '315', name: '恒丰银行' },
        { id: '305', name: '中国民生银行' },
        { id: '308', name: '招商银行' },
        { id: '303', name: '中国光大银行' },
        { id: '596', name: '韩国中小企业银行有限公司' },
        { id: '595', name: '新韩银行(中国)有限公司' },
        { id: '621', name: '华侨银行（中国）有限公司' },
        { id: '631', name: '泰国盘谷银行(大众有限公司)' },
        { id: '622', name: '大华银行（中国）有限公司' },
        { id: '563', name: '日本三井住友银行股份有限公司' },
        { id: '561', name: '三菱东京日联银行(中国）有限公司' },
        { id: '565', name: '日本山口银行股份有限公司' },
        { id: '593', name: '友利银行(中国)有限公司' },
        { id: '591', name: '韩国外换银行股份有限公司' },
        { id: '897', name: '广东农村信用合作社（收单）' },
        { id: '652', name: '比利时富通银行有限公司' },
        { id: '969', name: '(澳门地区)银行' },
        { id: '775', name: '联合银行(中国)有限公司' },
        { id: '989', name: '(香港地区)银行' },
        { id: '651', name: '比利时联合银行股份有限公司' },
        { id: '641', name: '奥地利中央合作银行股份有限公司' },
        { id: '781', name: '厦门国际银行' },
        { id: '787', name: '华一银行' },
        { id: '782', name: '法国巴黎银行（中国）有限公司' },
        { id: '532', name: '美国银行有限公司' },
        { id: '314', name: '农村商业银行（江苏）' },
        { id: '313', name: '城市商业银行' },
        { id: '316', name: '浙商银行' },
        { id: '319', name: '徽商银行股份有限公司' },
        { id: '317', name: '农村合作银行' },
        { id: '306', name: '广东发展银行' },
        { id: '304', name: '华夏银行' },
        { id: '307', name: '深圳发展银行' },
        { id: '310', name: '上海浦东发展银行' },
        { id: '309', name: '兴业银行' },
        { id: '507', name: '创兴银行有限公司' },
        { id: '505', name: '中国银行（香港）有限公司' },
        { id: '509', name: '星展银行（中国）有限公司' },
        { id: '531', name: '花旗银行（中国）有限公司' },
        { id: '512', name: '永隆银行' },
        { id: '402', name: '农村信用社（含北京农村商业银行）、东莞农信' },
        { id: '320', name: '镇银行有限责任公司' },
        { id: '403', name: '中国邮政储蓄银行（代收付）' },
        { id: '504', name: '恒生银行(中国)有限公司' },
        { id: '502', name: '东亚银行' },
        { id: '594', name: '韩国产业银行' },
        { id: '694', name: '法国东方汇理银行股份有限公司' },
        { id: '691', name: '法国兴业银行（中国)有限公司' },
        { id: '712', name: '德意志银行（中国）有限公司' },
        { id: '695', name: '法国外贸银行股份有限公司' },
        { id: '898', name: '银联商务（收单）' },
        { id: '785', name: '华商银行' },
        { id: '671', name: '渣打银行' },
        { id: '662', name: '荷兰安智银行股份有限公司' },
        { id: '751', name: '加拿大丰业银行有限公司' },
        { id: '742', name: '瑞士银行' },
        { id: '771', name: '摩根士丹利国际银行（中国）有限公司' },
        { id: '761', name: '澳大利亚和新西兰银行集团有限公司' },
        { id: '715', name: '德国巴伐利亚州银行' },
        { id: '713', name: '德国商业银行股份有限公司' },
        { id: '732', name: '意大利联合圣保罗银行股份有限公司' },
        { id: '716', name: '德国北德意志州银行' },
        { id: '672', name: '英国苏格兰皇家银行公众有限公司' },
        { id: '714', name: '德国西德银行股份有限公司' },
        { id: '623', name: '星展银行（中国）有限公司' },
        { id: '711', name: '德国德累斯登银行股份公司' },
        { id: '741', name: '瑞士信贷银行股份有限公司' },
        { id: '752', name: '加拿大蒙特利尔银行有限公司' },
        { id: '776', name: '荷兰合作银行有限公司' },
        { id: '597', name: '韩亚银行（中国）有限公司' },
        { id: '661', name: '荷兰银行' },
    ],
    // 岗位类型列表
    jobtype:[
        {id:"2",name:"技术负责人"},
        {id:"8",name:"安全员"},
        {id:"10",name:"材料员"},
        {id:"11",name:"机械员"},
        {id:"4",name:"专业监理工程师"},
        {id:"7",name:"质量员"},
        {id:"5",name:"监理员"},
        {id:"12",name:"劳务员"},
        {id:"9",name:"标准员"},
        {id:"3",name:"总监理工程师"},
        {id:"6",name:"施工员"},
        {id:"99",name:"其他"},
        {id:"1",name:"项目经理"},
        {id:"14",name:"安全监理工程师"},
        {id:"13",name:"副总监理工程师"},
        {id:"15",name:"监理工程师"},
        {id:"18",name:"项目总工程师"},
        {id:"17",name:"监理安全员"},
        {id:"19",name:"工程经理"},
        {id:"20",name:"项目管理员"},
        {id:"21",name:"项目副经理"},
        {id:"22",name:"项目总监"},
        {id:"23",name:"总监理工程师代表"},
        {id:"24",name:"测量员"},
        {id:"25",name:"试验员"},
        {id:"26",name:"造价员"},
        {id:"27",name:"质量负责人"},
        {id:"28",name:"安全负责人"},
        {id:"29",name:"技术负责人"},
        {id:"30",name:"生产经理"},
        {id:"31",name:"物资材料工程师"},
        {id:"32",name:"项目工程师"},
        {id:"33",name:"资料员"},
    ],
    // 职员状态列表
    managestatus:[
        {id:"0",name:"离职"},
        {id:"1",name:"在职"},
    ],
    // 管理类型列表
    managetype: [
        {id: "1",name: "监理从业人员"},
        {id: "2",name: "施工管理人员"},
    ]
}

export default LzSet



// WEBPACK FOOTER //
// ./src/configure/lz.js